import { grey } from '@material-ui/core/colors'
import { BORAL_GREEN } from 'Constants/Theme/Theme.constants'

const plusLoadModalStyle = ({ theme }: { theme: any}) => ({
  modalContent: {
    minWidth: '360px',
    minHeight: '360px',
  },
  quantityConfirming: {
    color: BORAL_GREEN,
    fontSize: '60px',
    fontWeight: 'lighter',
    marginTop: '21px',
  },
  alertWrapper: {

  },
  largePlus: {
    color: '#000',
    fontSize: '60px',
    fontWeight: 'lighter',
    top: '5px',
    position: 'relative',
    marginRight: theme.spacing(1) * 2,
  },
  largeInput: {
    // color: '#000',
    fontSize: '60px',
    fontWeight: '300',
  },
  largeLabel: {
    color: '#00000080',
    fontSize: '60px',
    fontWeight: '300',
  },
})

export default plusLoadModalStyle
